/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-plusplus */
import { differenceInCalendarDays, format } from 'date-fns';
import Compress from 'react-image-file-resizer';
import Toast from '../components/molecules/Toast';
import dummyImg from '../../src/assets/avatar-2.svg';


/**
 * The workspace the user last switched to, read by fetchWrapper so every
 * request is scoped to it (as the `X-Workspace-Id` header) regardless of
 * which workspace is baked into their JWT. Written by authContext whenever
 * the active workspace changes, and read back on the next page load so a
 * switch survives a reload instead of reverting to the user's default.
 */
export const ACTIVE_WORKSPACE_COOKIE = 'activeWorkspaceId';

const getCookieSecurityFlags = () => {
  const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
  return {
    sameSite: isHttps ? 'Strict' : 'Lax',
    secure: isHttps ? '; Secure' : '',
  };
};

export const setCookie = (name, value, days, domain) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  const domainPart = domain ? `; domain=${domain}` : '';
  const { sameSite, secure } = getCookieSecurityFlags();

  document.cookie = `${name}=${encodeURIComponent(value || '')}${expires}; path=/${domainPart}; SameSite=${sameSite}${secure}`;

  return true;
};

export const getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = typeof document !== 'undefined' && document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const raw = c.substring(nameEQ.length, c.length);
      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    }
  }
  return null;
};

export const clearCookie = name => {
  if (typeof document !== 'undefined') {
    const { sameSite, secure } = getCookieSecurityFlags();
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=${sameSite}${secure}`;
  } else {
    console.warn('clearCookie function called in a non-browser environment');
  }
  return true;
};

export const clearAllCookies = () => {
  clearCookie(process.env.REACT_APP_AI_TOKEN_COOKIE);
  clearCookie(process.env.REACT_APP_AI_STATUS_COOKIE);
  clearCookie(ACTIVE_WORKSPACE_COOKIE);
};

export const formatNumber = number => {
  return new Intl.NumberFormat().format(number);
};

export const getGreetingMessage = () => {
  const hours = new Date().getHours();

  if (hours >= 5 && hours < 12) {
    return 'Good Morning';
  } else if (hours >= 12 && hours < 17) {
    return 'Good Afternoon';
  } else {
    return 'Good Evening'; // Covers 5 PM to 4:59 AM
  }
};

export const getPlanType = ({ plan, isProduction, planType }) => {
  const productionPrices = {
    monthly: {
      'Basic Plan': 'price_1TAALNKobo1HKNlW0CN844CA',
      'Pro Plan': 'price_1TAALMKobo1HKNlWqd4ZU79Z',
      'Enterprise Plan': 'price_1TAALLKobo1HKNlW4LXrBoj9',
    },
    yearly: {
      'Basic Plan': 'price_1TAALNKobo1HKNlW0gU2Ioez',
      'Pro Plan': 'price_1TAALMKobo1HKNlW3AmndSHt',
      'Enterprise Plan': 'price_1TAALLKobo1HKNlW9Tf5NLDt',
    },
  };

  const devPrices = {
    monthly: {
      'Basic Plan': 'price_1Sru5j3rqlOQ0ksErLOiZosp',
      'Pro Plan': 'price_1Sru5o3rqlOQ0ksEBmy3tWMH',
      'Enterprise Plan': 'price_1Sru5l3rqlOQ0ksEVx6HGLvP',
    },
    yearly: {
      'Basic Plan': 'price_1Sru5i3rqlOQ0ksEYmr6KGrH',
      'Pro Plan': 'price_1Sru5n3rqlOQ0ksEiiotMxhJ',
      'Enterprise Plan': 'price_1Sru5k3rqlOQ0ksEitoa9mYw',
    },
  };

  const prices = isProduction ? productionPrices : devPrices;
  return prices?.[plan]?.[planType] ?? null;
};

export const getUnitPrice = ({ plan, planType }) => {
  const unitPrices = {
    monthly: {
      'Basic Plan': 49,
      'Pro Plan': 99,
      'Enterprise Plan': 198,
    },
    yearly: {
      'Basic Plan': 468,
      'Pro Plan': 948,
      'Enterprise Plan': 1908,
    },
  };

  return unitPrices?.[plan]?.[planType] ?? null;
};

// Helper function to normalize CSV headers
export const normalize = str =>
  String(str || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');

// helper functions for create import job  column mappaing

export const normalizeRows = rows =>
  rows.map(row => {
    const newRow = {};
    Object.keys(row).forEach(col => {
      newRow[normalize(col)] = row[col];
    });
    return newRow;
  });

export const validateMapping = ({ first, last, email, company }) => {
  return (first && last && email) || (first && last && company);
};

// ---- Contact CSV import: rows are the payload objects from mapRowsToPayload ----

const IMPORT_PLACEHOLDERS = new Set(['NULL', 'NONE', 'N/A', 'NA', 'EMPTY', 'UNDEFINED']);
const IMPORT_EMAIL_REGEX = /^[A-Z0-9]+([._%+-][A-Z0-9]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)*\.[A-Z]{2,}$/i;
const LINKEDIN_URN_REGEX = /^ACo[A-Za-z0-9_-]{20,}$/;
const NAME_PRONOUNS_REGEX = /\(\s*(?:he|him|his|she|her|hers|they|them|theirs)(?:\s*\/\s*(?:he|him|his|she|her|hers|they|them|theirs))*\s*\)/gi;
const NAME_HONORIFIC_REGEX = /^(?:dr|mr|mrs|ms|miss|prof|eng|engr)\.?\s+/i;
const NAME_EMOJI_REGEX = /[☀-➿]|️|‍|[\uD83C-\uD83E][\uDC00-\uDFFF]/g;

const importValue = value => {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  return text && !IMPORT_PLACEHOLDERS.has(text.toUpperCase()) ? text : '';
};

const linkedinPublicIdFromUrl = value => {
  const match = String(value || '').match(/linkedin\.com\/in\/([^/?#\s]+)/i);
  if (!match) return '';
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

/**
 * "Ganesh Kendre (He/Him)" -> { first_name: 'Ganesh', last_name: 'Kendre' }.
 * Pronouns, honorifics, emojis and anything after a comma ("John Doe, MBA") are
 * dropped; other brackets stay ("Alicia Whitbread (Jenkins)" keeps "(Jenkins)").
 * One word gives a first name only.
 */
export const splitFullName = value => {
  const name = String(value ?? '')
    .replace(NAME_PRONOUNS_REGEX, ' ')
    .replace(NAME_EMOJI_REGEX, ' ')
    .split(',')[0]
    .replace(/\s+/g, ' ')
    .trim()
    .replace(NAME_HONORIFIC_REGEX, '');
  if (!name) return { first_name: '', last_name: '' };
  const [first, ...rest] = name.split(' ');
  return { first_name: first, last_name: rest.join(' ') };
};

/**
 * Splits a full name mapped onto First Name when no Last Name column is mapped
 * (the LinkedIn export has one "name" column), and fills linkedin_urn /
 * profile_id from whatever the CSV carried (a URN in the profile id column, a
 * profile URL).
 */
export const normalizeImportLead = lead => {
  const out = { ...lead };
  // null = Last Name not mapped at all; '' = mapped but empty on this row, left as is.
  if (out.last_name === null || out.last_name === undefined) {
    Object.assign(out, splitFullName(importValue(out.first_name)));
  }

  let urn = importValue(out.linkedin_urn).replace(/^urn:li:fsd_profile:/i, '');
  let publicId = importValue(out.profile_id);
  if (LINKEDIN_URN_REGEX.test(publicId)) {
    urn = urn || publicId;
    publicId = '';
  } else if (/linkedin\.com\/in\//i.test(publicId)) {
    publicId = linkedinPublicIdFromUrl(publicId);
  }
  if (!publicId) {
    const fromUrl = linkedinPublicIdFromUrl(out.linkedin_url);
    if (LINKEDIN_URN_REGEX.test(fromUrl)) urn = urn || fromUrl;
    else publicId = fromUrl;
  }

  out.linkedin_urn = LINKEDIN_URN_REGEX.test(urn) ? urn : '';
  out.profile_id = publicId.replace(/^\/+|\/+$/g, '').toLowerCase();
  return out;
};

export const hasImportLinkedinIdentity = lead => Boolean(lead?.linkedin_urn || lead?.profile_id);

/**
 * Keeps rows that can be saved: first + last name with an email or company, or
 * a LinkedIn URN / profile id. Invalid emails are blanked rather than dropping
 * the row; rows with a placeholder company ("----") or a blacklisted email
 * domain are dropped.
 */
export const filterImportLeads = (leads, { blacklistDomains = [] } = {}) => {
  const blocked = new Set(blacklistDomains.map(domain => String(domain || '').toLowerCase()));
  const kept = [];
  let blockedCount = 0;

  leads.forEach(raw => {
    const lead = { ...raw };
    const email = importValue(lead.email).toLowerCase();
    lead.email = IMPORT_EMAIL_REGEX.test(email) ? email : '';
    if (/^-+$/.test(String(lead.company_name ?? '').trim())) return;

    if (lead.email && blocked.has(lead.email.split('@')[1])) {
      blockedCount++;
      return;
    }

    const hasName = importValue(lead.first_name) && importValue(lead.last_name);
    const hasNameAndContact = hasName && (lead.email || importValue(lead.company_name));
    if (hasNameAndContact || hasImportLinkedinIdentity(lead)) kept.push(lead);
  });

  return { leads: kept, blockedCount };
};

const importLeadKeys = lead => {
  const keys = [];
  if (lead.linkedin_urn) keys.push(`u:${lead.linkedin_urn}`);
  if (lead.profile_id) keys.push(`p:${lead.profile_id}`);
  if (lead.email) keys.push(`e:${lead.email}`);
  const first = importValue(lead.first_name).toLowerCase();
  const last = importValue(lead.last_name).toLowerCase();
  const company = importValue(lead.company_name).toLowerCase();
  // Name + company only identifies rows with no email and no LinkedIn id, as before:
  // two "John Smith"s at Acme with different emails stay two contacts.
  if (!lead.email && !hasImportLinkedinIdentity(lead) && first && last && company) {
    keys.push(`n:${first}|${last}|${company}`);
  }
  return keys;
};

/**
 * Drops rows that repeat a person already in the file: same LinkedIn URN,
 * profile id or email, or (without a LinkedIn id) same name + company. Two rows
 * with different URNs are never duplicates of each other.
 */
export const dedupeImportLeads = leads => {
  const urnByKey = new Map();
  const unique = [];
  let duplicateCount = 0;

  leads.forEach(lead => {
    const keys = importLeadKeys(lead);
    const isDuplicate = keys.some(key => {
      if (!urnByKey.has(key)) return false;
      const seenUrn = urnByKey.get(key);
      return !(lead.linkedin_urn && seenUrn && seenUrn !== lead.linkedin_urn);
    });
    if (isDuplicate) {
      duplicateCount++;
      return;
    }
    keys.forEach(key => {
      if (!urnByKey.has(key)) urnByKey.set(key, lead.linkedin_urn || '');
    });
    unique.push(lead);
  });

  return { leads: unique, duplicateCount };
};

export const mapRowsToPayload = (rows, dragableData, dragItems, predefinedFields) =>
  rows.map(row => {
    const mappedRow = {};
    const customFields = {};

    dragableData.forEach((field, index) => {
      // dragItems.root holds objects with rowKey produced in handleOnDrop
      const mappedItem = dragItems.root?.[index];
      const rowKey = mappedItem?.rowKey || null;
      const value = rowKey && row[rowKey] !== undefined ? row[rowKey] : null;

      const isPredefined = predefinedFields.some(p => p.key === field.key);

      if (isPredefined) {
        mappedRow[field.key] = value;
      } else {
        customFields[field.key] = value;
      }
    });

    mappedRow.custom_fields = customFields;
    return mappedRow;
  });

/**
 * Re-applies star / pin values the user set locally on top of a thread that has
 * just come back from the server.
 *
 * Toggling either flag triggers a page-1 refetch. That read can be issued
 * before the write it was triggered by is visible, so the server's copy of the
 * flag is not authoritative for a moment — trusting it makes the star light up
 * and then quietly go out again. Each override is dropped as soon as the server
 * reports the same value, so this never masks a genuine change made elsewhere.
 *
 * `overridesRef` is a ref holding a Map of thread id -> partial thread.
 */
export const applyFlagOverrides = (thread, overridesRef) => {
  const overrides = overridesRef?.current;
  if (!overrides?.size || !thread?.id) return thread;

  const override = overrides.get(thread.id);
  if (!override) return thread;

  const settled = Object.keys(override).filter(key => !!thread[key] === !!override[key]);
  if (settled.length) {
    const remaining = { ...override };
    settled.forEach(key => delete remaining[key]);
    if (Object.keys(remaining).length) overrides.set(thread.id, remaining);
    else overrides.delete(thread.id);
  }

  return { ...thread, ...override };
};

// Helper to order threads: (star + pin) first, then pin-only, then star-only, then others.
export const sortThreadsByFlags = threads => {
  if (!Array.isArray(threads)) return threads;

  const withIndex = threads.map((thread, idx) => ({
    thread,
    idx,
  }));

  const groupRank = t => {
    const pinned = !!t.isPinned;
    const starred = !!t.isStarred;
    if (pinned && starred) return 0; // both
    if (pinned) return 1; // pin only
    if (starred) return 2; // star only
    return 3; // none
  };

  withIndex.sort((a, b) => {
    const ga = groupRank(a.thread);
    const gb = groupRank(b.thread);
    if (ga !== gb) return ga - gb;

    // Within the "none" group, use original index (before any flags) if available,
    // otherwise fall back to the current index to keep stable ordering.
    if (ga === 3) {
      const ia = typeof a.thread._originalIndex === 'number' ? a.thread._originalIndex : a.idx;
      const ib = typeof b.thread._originalIndex === 'number' ? b.thread._originalIndex : b.idx;
      return ia - ib;
    }

    // For flagged groups, keep current relative order.
    return a.idx - b.idx;
  });

  return withIndex.map(x => x.thread);
};

export const formatStatus = status => {
  if (status === 'WAITING_FOR_REPLY') {
    return 'Outgoing E-mail';
  }
  return status
    ?.toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};

// Calculate statistics based on mapped columns
export const calculateStatisticsFromMappedColumns = (rows, dragableData, dragItems, domains_data, columnNames) => {
  const getMappedRowKey = key => {
    const index = dragableData.findIndex(item => item.key === key);
    return dragItems.root?.[index]?.rowKey || null;
  };

  const emailRowKey = getMappedRowKey('email');

  // Find contact column from original column names
  const contactColumnNames = ['contact', 'contacts', 'contact number', 'phone', 'phone number'];
  let contactColumn = null;
  if (columnNames && Array.isArray(columnNames)) {
    contactColumn = columnNames.find(col => {
      if (!col) return false;
      const normalizedCol = normalize(col);
      return contactColumnNames.some(name => normalize(name) === normalizedCol);
    });
  }

  const emailRegex = /^[A-Z0-9]+([._%+-][A-Z0-9]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)*\.[A-Z]{2,}$/i;
  const blacklistDomains = domains_data?.data?.items?.map(d => d.domain?.toLowerCase()) || [];

  let totalEmails = 0;
  let totalContacts = 0;
  const blockedRows = [];
  const duplicateEmails = [];
  const seenEmails = new Set();

  rows.forEach(row => {
    // Count emails from mapped email column (rowKey-based)
    if (emailRowKey) {
      const emailValue = row[emailRowKey];

      if (emailValue) {
        const email = String(emailValue).trim().toLowerCase();
        if (email && emailRegex.test(email)) {
          totalEmails++;

          // Check for blocked domains
          const domain = email.split('@')[1]?.toLowerCase();
          if (blacklistDomains.includes(domain)) {
            blockedRows.push(row);
          }

          // Check for duplicates
          if (seenEmails.has(email)) {
            duplicateEmails.push(row);
          } else {
            seenEmails.add(email);
          }
        }
      }
    }

    // Count contacts from contact column (if exists in original CSV)
    if (contactColumn) {
      const normalizedContactCol = normalize(contactColumn);
      const contactValue = row[normalizedContactCol];
      if (contactValue && String(contactValue).trim()) {
        totalContacts++;
      }
    }
  });

  return {
    totalEmails,
    totalContacts,
    blockedRows,
    duplicateEmails,
    totalContactsInLists: rows.length, // Total rows after filtering
  };
};

export const getColumnMapping = (dragableData, dragItems) =>
  dragableData.map((item, index) => dragItems.root?.[index] && item.key).filter(Boolean);

// Helper function to determine if a row should be kept
function shouldKeepRow(row, columnNames) {
  const get = colName => {
    // Normalize the search column name (e.g., 'company_name')
    const normalizedSearchName = normalize(colName);
    // Find column by matching normalized names (handles 'Company Name', 'company name', 'COMPANY_NAME', etc.)
    const index = columnNames.findIndex(c => normalize(c) === normalizedSearchName);
    if (index === -1) return '';

    const value = row[index];
    // Handle both string and number values
    if (value === null || value === undefined) return '';
    if (typeof value === 'number') return String(value);
    if (typeof value === 'string') {
      // Trim and remove surrounding quotes if present
      let trimmed = value.trim();
      // Remove surrounding single or double quotes (handle mixed quotes like '1234")
      if (trimmed.length > 0) {
        // Remove leading quotes
        if (trimmed.startsWith('"') || trimmed.startsWith("'")) {
          trimmed = trimmed.slice(1);
        }
        // Remove trailing quotes
        if (trimmed.endsWith('"') || trimmed.endsWith("'")) {
          trimmed = trimmed.slice(0, -1);
        }
        trimmed = trimmed.trim();
      }
      return trimmed;
    }
    return String(value).trim();
  };

  const firstName = get('first_name');
  const lastName = get('last_name');
  const email = get('email');
  const companyName = get('company_name');
  const profileId = get('profile_id');

  const hasName = firstName && lastName;

  // Check if profile_id column exists and has a value
  const profileIdColumnIndex = columnNames.findIndex(c => normalize(c) === 'profile_id');
  const profileIdRawValue = profileIdColumnIndex !== -1 ? row[profileIdColumnIndex] : null;

  // Check if raw value exists (handles numbers, strings with quotes, etc.)
  const hasRawProfileId =
    profileIdRawValue !== null &&
    profileIdRawValue !== undefined &&
    profileIdRawValue !== '' &&
    (typeof profileIdRawValue === 'number' || String(profileIdRawValue).trim() !== '');

  // Check if processed profile_id is valid (non-empty string)
  const hasValidProfileId = profileId && profileId !== '' && profileId.trim() !== '';

  if (firstName && lastName && email && companyName && (hasValidProfileId || hasRawProfileId)) {
    return true;
  }

  // Accept rows with profile_id (handles both string and number, including raw values)
  if (hasValidProfileId || hasRawProfileId) {
    return true;
  }

  // Accept firstname + lastname + email
  if (hasName && email) return true;

  // Accept firstname + lastname + company
  if (hasName && companyName) return true;

  return false;
}

// Reverse map for the Windows-1252 characters in 0x80-0x9F.
const CP1252_TO_BYTE = {
  0x20ac: 0x80, 0x201a: 0x82, 0x0192: 0x83, 0x201e: 0x84, 0x2026: 0x85, 0x2020: 0x86, 0x2021: 0x87,
  0x02c6: 0x88, 0x2030: 0x89, 0x0160: 0x8a, 0x2039: 0x8b, 0x0152: 0x8c, 0x017d: 0x8e, 0x2018: 0x91,
  0x2019: 0x92, 0x201c: 0x93, 0x201d: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97, 0x02dc: 0x98,
  0x2122: 0x99, 0x0161: 0x9a, 0x203a: 0x9b, 0x0153: 0x9c, 0x017e: 0x9e, 0x0178: 0x9f,
};
// A UTF-8 lead byte read as Latin-1 (Ã, Ä, â, ð...) followed by a continuation byte.
const MOJIBAKE_HINT =
  /[Â-ô][\u0080-¿ŒœŠšŸŽžƒˆ˜–—‘-„†-•…‰‹›€™]/;

/**
 * Undoes text that was UTF-8 but got decoded as Windows-1252 somewhere before
 * it reached us ("SÄƒ" -> "Să", "ðŸš€" -> "🚀"). Text that does not decode
 * cleanly as UTF-8 is returned unchanged, so correct text is never touched.
 */
export const repairMojibake = value => {
  if (typeof value !== 'string' || !MOJIBAKE_HINT.test(value) || typeof TextDecoder === 'undefined') return value;
  const bytes = new Uint8Array(value.length);
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code <= 0xff) bytes[i] = code;
    else if (CP1252_TO_BYTE[code] !== undefined) bytes[i] = CP1252_TO_BYTE[code];
    else return value;
  }
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return value;
  }
};

// Main CSV handling function
export const handleOnDrop = async (
  rawData,
  file,
  user,
  setFormData,
  form,
  Toast,
  domains_data,
  { checkCredits = false } = {},
) => {
  try {
    if (!rawData?.data || rawData.data.length === 0) {
      throw new Error('CSV is empty! Please upload a valid file.');
    }

    const columnNames = rawData.data[0].map(repairMojibake);
    const dataRows = rawData.data.slice(1);

    // Remove completely empty rows
    const cleanedData = dataRows.filter(row => !row.every(cell => cell.trim() === ''));
    if (cleanedData.length === 0) {
      throw new Error('CSV has no records! Please upload a valid file.');
    }

    if (checkCredits && cleanedData.length > user?.remainingCredits) {
      throw new Error('Low credits! Please update your package.');
    }

    const blacklistDomains = domains_data?.data?.items?.map(d => d.domain?.toLowerCase()) || [];
    const emailRegex = /^[A-Z0-9]+([._%+-][A-Z0-9]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)*\.[A-Z]{2,}$/i;

    const contactColumnNames = ['contact', 'contacts', 'contact number', 'phone', 'phone number'];
    const contactColumnIndex = columnNames.findIndex(col => contactColumnNames.includes(col?.trim().toLowerCase()));

    let processedRows = [];
    let blockedRows = [];
    let duplicateEmails = [];
    const seenEmails = new Set();
    const allEmails = [];

    // Process all rows without filtering - filtering will happen after column mapping
    cleanedData.forEach(row => {
      const obj = {};

      columnNames.forEach((col, index) => {
        // Create a unique key per column index so duplicate headers
        // (e.g., multiple "First Name" columns) remain distinct.
        const key = `${normalize(col)}_${index}`;
        const rawValue = row[index];
        let normalizedValue = '';

        if (rawValue === null || rawValue === undefined) {
          normalizedValue = '';
        } else if (typeof rawValue === 'number') {
          normalizedValue = String(rawValue);
        } else if (typeof rawValue === 'string') {
          // Trim and remove surrounding quotes if present (handle mixed quotes like '1234")
          let trimmed = rawValue.trim();
          if (trimmed.length > 0) {
            // Remove leading quotes
            if (trimmed.startsWith('"') || trimmed.startsWith("'")) {
              trimmed = trimmed.slice(1);
            }
            // Remove trailing quotes
            if (trimmed.endsWith('"') || trimmed.endsWith("'")) {
              trimmed = trimmed.slice(0, -1);
            }
            trimmed = trimmed.trim();
          }
          normalizedValue = repairMojibake(trimmed);
        } else {
          let trimmed = String(rawValue).trim();
          if (
            (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
            (trimmed.startsWith("'") && trimmed.endsWith("'"))
          ) {
            trimmed = trimmed.slice(1, -1).trim();
          }
          normalizedValue = trimmed;
        }

        obj[key] = normalizedValue || '';
      });

      // Track email for statistics (but don't filter based on it)
      const emailColIndex = columnNames.findIndex(c => normalize(c) === 'email');
      const emailKey = emailColIndex !== -1 ? `email_${emailColIndex}` : null;
      const email = emailKey ? obj[emailKey]?.toLowerCase() || null : null;

      // Track blocked domains and duplicates for reporting, but don't filter them out
      if (email && emailRegex.test(email)) {
        const domain = email.split('@')[1]?.toLowerCase();
        if (blacklistDomains.includes(domain)) {
          blockedRows.push(obj);
        }

        // Duplicate email
        if (seenEmails.has(email)) {
          duplicateEmails.push(obj);
        }

        seenEmails.add(email);
        allEmails.push(email);
      }

      // Add all rows to processedRows - filtering will happen after column mapping
      processedRows.push(obj);
    });

    // Set form data (no stats/validation; keep raw rows to preserve all columns)
    setFormData({
      file,
      columnNames, // original CSV headers
      rows: processedRows, // normalized-key objects
      rawRows: cleanedData, // original row arrays, preserve every column by index
      blockedRows: [],
      duplicateEmails: [],
      totalContacts: 0,
      totalEmails: 0,
    });

    form.setFieldsValue({ csvfile: file });
  } catch ({ message }) {
    Toast({ type: 'error', message });
  }
};

// Helper function to create a CSV File from filtered rows
export const createCSVFileFromRows = (rows, columnNames, originalFileName = 'filtered_data.csv') => {
  if (!rows || rows.length === 0 || !columnNames || columnNames.length === 0) {
    return null;
  }

  // Convert rows array of objects to CSV format
  const header = columnNames
    .map(col => {
      // Escape quotes and wrap in quotes if contains comma, newline, or quote
      const escaped = String(col).replace(/"/g, '""');
      return /[,"\n]/.test(escaped) ? `"${escaped}"` : escaped;
    })
    .join(',');

  const csvRows = rows.map(row => {
    return columnNames
      .map(col => {
        const value = row[col] ?? '';
        // Convert value to string and escape quotes
        const stringValue = String(value).replace(/"/g, '""');
        // Wrap in quotes if contains comma, newline, or quote
        return /[,"\n]/.test(stringValue) ? `"${stringValue}"` : stringValue;
      })
      .join(',');
  });

  const csvContent = [header, ...csvRows].join('\n');

  // Create a Blob and then a File from it
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Generate filename from original file or use default
  const fileName = originalFileName ? `filtered_${originalFileName.replace(/\.[^/.]+$/, '')}.csv` : 'filtered_data.csv';

  return new File([blob], fileName, { type: 'text/csv' });
};

// Optimized function to read only CSV header without parsing entire file
export const readCSVHeaderOnly = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    // Check file extension
    const fileName = file.name.toLowerCase();
    const isXLSX = fileName.endsWith('.xlsx');

    // For XLSX files, we need to parse them differently
    // For now, we'll use react-papaparse which might handle it, or show an error
    if (isXLSX) {
      // XLSX files need special handling - for now, reject with helpful message
      // In the future, we can add xlsx library support
      reject(new Error('XLSX files are not yet supported for bulk upload. Please convert to CSV format.'));
      return;
    }

    // Read only first 64KB of the file (enough for headers and a few rows)
    const chunkSize = 64 * 1024; // 64KB
    const blob = file.slice(0, chunkSize);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const text = e.target.result;
        // Handle different line endings (Windows \r\n, Unix \n, Mac \r)
        let firstNewlineIndex = text.indexOf('\n');
        if (firstNewlineIndex === -1) {
          firstNewlineIndex = text.indexOf('\r');
        }

        if (firstNewlineIndex === -1) {
          // No newline found, treat entire chunk as header
          const headerLine = text.trim();
          if (!headerLine) {
            reject(new Error('CSV has no header row!'));
            return;
          }
          // Parse CSV header (handle quoted values)
          const columnNames = parseCSVLine(headerLine);
          resolve(columnNames);
        } else {
          // Remove \r if present (Windows line ending)
          let headerLine = text.substring(0, firstNewlineIndex).trim();
          if (headerLine.endsWith('\r')) {
            headerLine = headerLine.slice(0, -1).trim();
          }
          if (!headerLine) {
            reject(new Error('CSV has no header row!'));
            return;
          }
          const columnNames = parseCSVLine(headerLine);
          resolve(columnNames);
        }
      } catch (error) {
        reject(new Error(`Failed to read CSV header: ${error.message}`));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(blob);
  });
};

// Helper function to parse a single CSV line (handles quoted values)
const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        // Escaped quote
        current += '"';
        i++; // Skip next quote
      } else {
        // Toggle quote state
        inQuotes = !inQuotes;
      }
    } else if ((char === ',' || char === '\t') && !inQuotes) {
      // End of field
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  // Add last field
  result.push(current.trim());

  return result;
};

export const handleCampaignDrop = async (
  rawData,
  file,
  user,
  setFormData,
  form,
  Toast,
  domains_data,
) => {
  try {
    if (!rawData?.data || rawData?.data.length === 0) {
      throw new Error('CSV is empty! Please upload a valid file.');
    }
    const columnNames = rawData.data[0];

    const dataRows = rawData.data.slice(1);

    const cleanedData = dataRows.filter(row => !row.every(cell => cell.trim() === ''));
    if (cleanedData.length === 0) {
      throw new Error('CSV has no records! Please upload a valid file.');
    }

    const blacklistDomains = domains_data?.data?.items?.map(d => d.domain?.toLowerCase()) || [];

    if (cleanedData.length > user?.remainingCredits) {
      throw new Error('Low credits! Please update your package.');
    }

    let blockedRows = [];
    let duplicateEmails = [];
    let invalidRows = [];
    const seenEmails = new Set();
    const allEmails = [];

    const emailRegex = /^[A-Z0-9]+([._%+-][A-Z0-9]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)*\.[A-Z]{2,}$/i;

    // Process only rows with valid emails (detect email from values, not column name)
    const processedRows = cleanedData.filter((item, index) => {
      let email = null;
      let emailIndex = -1;

      // Scan all cell values in the row and pick the first valid email
      for (let i = 0; i < item.length; i++) {
        const cell = item[i];
        if (typeof cell !== 'string') continue;
        const trimmed = cell.trim().toLowerCase();
        if (trimmed && emailRegex.test(trimmed)) {
          email = trimmed;
          emailIndex = i;
          break;
        }
      }


      // If email is empty/null/undefined, skip this row
      if (!email || email.length === 0) {
        invalidRows.push(item);
        return false;
      }

      // If email has invalid format, skip this row
      if (!emailRegex.test(email)) {
        invalidRows.push(item);
        return false;
      }

      // Update the original row with trimmed/lowercased email
      if (emailIndex !== -1) {
        item[emailIndex] = email;
      }

      // Email exists and is valid format
      allEmails.push(email);

      const domain = email.split('@')[1]?.toLowerCase();

      // Check blacklist
      if (blacklistDomains.includes(domain)) {
        blockedRows.push(item);
        return false;
      }

      // Check for duplicates
      if (seenEmails.has(email)) {
        duplicateEmails.push(item);
        return false;
      }

      seenEmails.add(email);
      return true;
    });

    const formattedRows = processedRows?.map(row => {
      const obj = {};
      columnNames.forEach((col, index) => {
        let value = row[index] ?? '';
        if (typeof value === 'string' && value.includes('@')) {
          value = value.trim().toLowerCase();
        }

        const key = `${normalize(col)}_${index}`;
        obj[key] = value;
      });
      return obj;
    });

    const totalEmails = allEmails.length;

    // Create a new CSV file from the filtered rows
    const filteredCsvFile = createCSVFileFromRows(formattedRows, columnNames, file?.name);

    setFormData({
      file,
      columnNames,
      rowData: formattedRows.length,
      totalContacts: cleanedData.length,
      rows: formattedRows,
      blockedRows,
      duplicateEmails,
      invalidRows,
      totalEmails,
      filteredCsvFile,
    });
    form.setFieldsValue({
      csvfile: filteredCsvFile || file,
    });
  } catch ({ message }) {
    Toast({
      type: 'error',
      message,
    });
  }
};

export const downloadCSV = (filename, rows, columnNames) => {
  if (!rows || rows.length === 0) return;

  const header = columnNames?.join(',');
  const csv = [header, ...rows.map(row => row.map(v => `"${v}"`).join(','))].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Helper function to convert object keys to lowercase with underscores between words
export const normalizeKeys = (obj) => {
  const normalized = {};
  Object.keys(obj).forEach(key => {
    let normalizedKey = String(key || '')
      .trim();

    // Insert underscore before capital letters (for camelCase/PascalCase)
    normalizedKey = normalizedKey.replace(/([a-z])([A-Z])/g, '$1_$2');

    // Convert to lowercase and replace spaces, hyphens, dots with underscores
    normalizedKey = normalizedKey
      .toLowerCase()
      .replace(/\s+/g, '_') // Replace spaces with underscore
      .replace(/[-.]+/g, '_') // Replace hyphens and dots with underscore
      .replace(/_+/g, '_') // Replace multiple consecutive underscores with single underscore
      .replace(/^_+|_+$/g, ''); // Remove leading and trailing underscores

    normalized[normalizedKey] = obj[key];
  });
  return normalized;
};

// Helper function to create a CSV File from filtered rows
export const createCSVFileFromRowsForCampaign = (rows, columnNames, originalFileName = 'filtered_data.csv') => {
  if (!rows || rows.length === 0 || !columnNames || columnNames.length === 0) {
    return null;
  }

  // Convert rows array of objects to CSV format
  const header = columnNames
    .map(col => {
      // Escape quotes and wrap in quotes if contains comma, newline, or quote
      const escaped = String(col).replace(/"/g, '""');
      return /[,"\n]/.test(escaped) ? `"${escaped}"` : escaped;
    })
    .join(',');

  const csvRows = rows.map(row => {
    return columnNames
      .map(col => {
        const value = row[col] ?? '';
        // Convert value to string and escape quotes
        const stringValue = String(value).replace(/"/g, '""');
        // Wrap in quotes if contains comma, newline, or quote
        return /[,"\n]/.test(stringValue) ? `"${stringValue}"` : stringValue;
      })
      .join(',');
  });

  const csvContent = [header, ...csvRows].join('\n');

  // Create a Blob and then a File from it
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Generate filename from original file or use default
  const fileName = originalFileName ? `filtered_${originalFileName.replace(/\.[^/.]+$/, '')}.csv` : 'filtered_data.csv';

  return new File([blob], fileName, { type: 'text/csv' });
};

export const handleJsonFileUpload = async (file, onSuccess, form) => {
  if (!file) {
    if (form && typeof form.setFieldsValue === 'function') {
      Toast({ type: 'error', message: 'No file selected!' });
      return;
    }
  }

  if (file.size === 0) {
    Toast({ type: 'error', message: 'File is empty!' });
    return;
  }

  const reader = new FileReader();
  reader.onload = e => {
    try {
      const parsed = JSON.parse(e.target.result);
      onSuccess(parsed);

      if (form && typeof form.setFieldsValue === 'function') {
        form.setFieldsValue({
          csvfile: file,
        });
      }
    } catch (err) {
      Toast({
        type: 'error',
        message: 'Invalid JSON file!',
      });
    }
  };
  reader.readAsText(file);
};

export const calculatePercentage = (credits, totalCredits) => {
  if (credits < 0 || totalCredits <= 0) {
    return '---';
  }
  if (credits > totalCredits) {
    return 100;
  }
  const obtainedPercentage = (credits / totalCredits) * 100;
  // const remainingPercentage = 100 - obtainedPercentage;
  return obtainedPercentage.toFixed(0);
};
export const convertPdfBase64 = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });

export const compressImage = (file, type = 'JPEG') =>
  new Promise(resolve => {
    Compress.imageFileResizer(
      file,
      Infinity,
      Infinity,
      type,
      70,
      0,
      uri => {
        resolve(uri);
      },
      'base64',
    );
  });

export const capitalize = (str = '') => {
  const arr = str?.toLowerCase()?.split(' ');

  for (let i = 0; i < arr?.length; i++) {
    arr[i] = arr[i].charAt(0)?.toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr?.join(' ');
  return str2;
};

export const getStatusIconClass = (status = '') => {
  switch (status.trim().toLowerCase()) {
    case 'pending':
      return 'icon-clock';
    case 'processing':
      return 'icon-clock';
    case 'approved':
      return 'icon-check-circle';
    case 'rejected':
      return 'icon-error-circle';
    case 'cancelled':
      return 'icon-times-circle';
    default:
      return 'icon-warning';
  }
};

function changeTimezone(date, ianatz) {
  // suppose the date is 12:00 UTC
  const invdate = new Date(
    date.toLocaleString('en-US', {
      timeZone: ianatz,
    }),
  );

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  const diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract
}

export const getDateObject = e => changeTimezone(new Date(e), 'Canada/Eastern');

export const convertToCurrencyFormat = (amount = '0') =>
  `$${Number(amount)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const shortenString = (str, len = 10) => {
  if (!str) return null;
  if (str.length > len) {
    return `${str.substring(0, len)}...`;
  }
  return str;
};

export const convertReadable = (amount = 0) =>
  `${Math.abs(amount) > 999
    ? `${Math.sign(amount) * (Math.abs(amount) / 1000).toFixed(1)}K`
    : Math.sign(amount) * Math.abs(amount)
  }`;

export const convertToBase64 = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });

export const getVisitNo = visit => {
  switch (visit) {
    case 1:
      return `${String(visit)}st`;
    case 2:
      return `${String(visit)}nd`;
    case 3:
      return `${String(visit)}rd`;
    default:
      return `${String(visit)}th`;
  }
};
export const generatePsscode = length => {
  let zero = '';
  for (let index = 1; index < length; index++) {
    zero += '0';
  }
  const firstVal = 1 + zero;
  const secondVal = 9 + zero;
  return Math.floor(Number(firstVal) + Math.random() * Number(secondVal));
};

const validateImage = url =>
  new Promise((resolve, reject) => {
    const img = new Image(url);
    // eslint-disable-next-line no-multi-assign
    img.onerror = img.onabort = async function () {
      reject();
    };
    img.onload = function () {
      resolve();
    };
    img.src = url;
  });

const checkValidImageProtocol = url => {
  if (/(http(s?)):\/\//i.test(url)) {
    return true;
  }
  return false;
};

const checkValidImageExtension = url => {
  if (['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'].includes(url.split(/[#?]/)[0].split('.').pop().trim())) {
    return true;
  }
  return false;
};

export const checkInValidImage = async url => {
  try {
    await validateImage(url);
    return !(checkValidImageExtension(url) && checkValidImageProtocol(url));
  } catch (ex) {
    return true;
  }
};

export const convertToFormData = (payload, excludeKeys = []) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (excludeKeys.includes(key)) return; // Skip excluded keys

    if (value instanceof File) {
      // If value is a File, append it directly
      formData.append(key, value);
    } else if (Array.isArray(value)) {
      // Append arrays with indexed keys
      value.forEach((item, index) => {
        formData.append(`${key}[${index}]`, item);
      });
    } else if (typeof value === 'object' && value !== null) {
      // Convert objects to JSON string (except files)
      formData.append(key, JSON.stringify(value));
    } else {
      // Append primitives normally
      formData.append(key, value);
    }
  });

  return formData;
};

export const convertDateToISO = dateStr => {
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month}-${day}`;
};
// Format the date
const getOrdinalSuffix = day => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};
export const formatDateWithSuffix = dateObj => {
  const date = new Date(dateObj);

  const day = format(date, 'd'); // get the day without leading zeros
  const monthYear = format(date, 'MMMM, yyyy'); // get the month and year
  const ordinalSuffix = getOrdinalSuffix(parseInt(day)); // get the ordinal suffix
  return `${day}${ordinalSuffix} ${monthYear}`;
};

// Calculate the number of days left
export const daysLeft = dateObj => {
  const date = new Date(dateObj);
  const daysLeft = differenceInCalendarDays(date, new Date());

  return daysLeft < 10 ? `0${daysLeft} days` : `${daysLeft.toString()} days`;

  // return formatDistanceToNow(date, {addSuffix: false});
};

export const bas64toFile = async (dataUrl, fileName) => {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: 'image/jpg' });
};

export const removeSpaces = (str = '') => {
  return str.replace(/ /g, '');
};

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const handleCreditsNames = type => {
  if (type === 'enrichment_credits') {
    return 'Enrichment Credits';
  } else if (type === 'email_sent') {
    return 'Email Sent Credits';
  } else if (type === 'linkedin_scraper') {
    // One credit per lead the AI finds and adds (ICP search), not LinkedIn itself.
    return 'Lead Credits';
  } else if (type === 'email_finder') {
    return 'Email Finder Credits';
  } else if (type === 'ai_home') {
    return 'AI Home Credits';
  }
};

export const formatDate = isoDate => {
  const date = new Date(isoDate);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
};

export const formatDateWithSeperator = isoDate => {
  const date = new Date(isoDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day} - ${month} - ${year}`;
};

export const extractNameFromEmail = email => {
  return email
    ?.split('@')[0]
    ?.replace(/[._]/g, ' ')
    ?.replace(/\b\w/g, l => l.toUpperCase());
};

export const handleDirectDownload = async url => {
  if (!url) return;

  try {
    const a = document.createElement('a');
    a.href = url;

    const fileName = url.split('/').pop() || 'file.csv';
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    Toast({ type: 'error', message: error.message || 'Download failed' });
  }
};

export const exportData = (data, fileName) => {
  const csvContent = convertArrayOfObjectsToCSV(data);
  const csvBlob = new Blob([csvContent], { type: 'text/csv' });

  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(csvBlob);
  downloadLink.download = `${fileName}.csv`;
  downloadLink.click();
};

export const convertArrayOfObjectsToCSV = data => {
  if (!data || !data.length) return '';

  // Dynamically extract all unique keys from objects
  // const headers = Array.from(
  //   new Set(data.flatMap(obj => Object.keys(obj)))
  // );
  const headers = Array.from(new Set(data.flatMap(obj => Object.keys(obj)))).map(key => {
    // Replace underscores with space and capitalize each word
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  });

  const keys = Array.from(new Set(data.flatMap(obj => Object.keys(obj))));

  let csv = `${headers.join(',')}\n`;

  data.forEach(obj => {
    const row = keys.map(key => {
      let value = obj[key];

      // If value is an object/array, stringify it
      if (typeof value === 'object' && value !== null) {
        value = JSON.stringify(value);
      }

      if (typeof value === 'string') {
        value = value.replace(/"/g, '""');

        if (/[",\n]/.test(value)) {
          value = `"${value}"`;
        }
      }

      return value ?? '';
    });

    csv += `${row.join(',')}\n`;
  });

  return csv;
};

// Compare two values to check if they're the same
export const areValuesEqual = (oldValue, newValue) => {
  // Handle null/undefined cases
  if (oldValue === null || oldValue === undefined) {
    return (
      newValue === null ||
      newValue === undefined ||
      newValue === '' ||
      (Array.isArray(newValue) && newValue.length === 0)
    );
  }
  if (newValue === null || newValue === undefined) {
    return (
      oldValue === null ||
      oldValue === undefined ||
      oldValue === '' ||
      (Array.isArray(oldValue) && oldValue.length === 0)
    );
  }

  // Handle arrays (multi-select)
  if (Array.isArray(oldValue) && Array.isArray(newValue)) {
    if (oldValue.length !== newValue.length) return false;
    if (oldValue.length === 0) return true;
    // Compare arrays of objects or primitives
    const oldValues = oldValue
      .map(v => (typeof v === 'object' && v?.value !== undefined ? v.value : v))
      .filter(v => v !== undefined && v !== null)
      .sort();
    const newValues = newValue
      .map(v => (typeof v === 'object' && v?.value !== undefined ? v.value : v))
      .filter(v => v !== undefined && v !== null)
      .sort();
    return JSON.stringify(oldValues) === JSON.stringify(newValues);
  }

  // Handle objects (single select with object)
  if (typeof oldValue === 'object' && typeof newValue === 'object' && oldValue !== null && newValue !== null) {
    const oldVal = oldValue?.value !== undefined ? oldValue.value : oldValue;
    const newVal = newValue?.value !== undefined ? newValue.value : newValue;
    return oldVal === newVal;
  }

  // Handle primitives
  return oldValue === newValue;
};

export const stripHtml = html => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  tmp.querySelectorAll('style, script').forEach(el => el.remove());
  return tmp.textContent || tmp.innerText || '';
};

const UNSUBSCRIBE_FOOTER_REGEX =
  /(?:if you no longer wish to receive (?:these emails|updates|emails)[\s,.!-]*(?:you can[\s,.!-]*)?(?:click|unsubscribe) here|(?:click|unsubscribe) here[\s,.!-]*if you no longer wish to receive (?:these emails|updates|emails))\.?/gi;

export const stripUnsubscribeFooter = input => {
  if (input == null) return '';
  const str = String(input);
  if (!str) return '';

  // No HTML — straight regex.
  if (!/<[a-z][^>]*>/i.test(str)) {
    return str.replace(UNSUBSCRIBE_FOOTER_REGEX, '');
  }

  // HTML — DOM-based removal of footer containers.
  try {
    const doc = new DOMParser().parseFromString(`<!doctype html><body>${str}</body>`, 'text/html');
    const root = doc.body;
    Array.from(root.querySelectorAll('*')).forEach(el => {
      const text = el.textContent || '';
      if (!text) return;
      const remaining = text.replace(UNSUBSCRIBE_FOOTER_REGEX, '').trim();
      if (remaining.length === 0) el.remove();
    });
    return root.innerHTML;
  } catch (e) {
    return str.replace(UNSUBSCRIBE_FOOTER_REGEX, '');
  }
};

export const LINKEDIN_SCRAPE_LEAD_LIMITS = {
  basic: 500,
  salesNavigator: 2000,
};

/**
 * Detects LinkedIn scrape URL type (matches backend `/sales` check for Sales Navigator).
 * @returns {'sales_navigator'|'basic'|null}
 */
export const getLinkedInScrapeUrlType = input => {
  if (input == null || input === '') return null;
  const trimmed = String(input).trim();
  try {
    const parsed = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
    const host = parsed.hostname.replace(/^www\./i, '').toLowerCase();
    if (host !== 'linkedin.com') return null;

    const path = parsed.pathname.toLowerCase();
    if (path.includes('/sales')) return 'sales_navigator';
    if (path.includes('/search/results')) return 'basic';
    return null;
  } catch {
    return null;
  }
};

export const getLinkedInScrapeLeadLimit = input => {
  const type = getLinkedInScrapeUrlType(input);
  if (type === 'sales_navigator') return LINKEDIN_SCRAPE_LEAD_LIMITS.salesNavigator;
  if (type === 'basic') return LINKEDIN_SCRAPE_LEAD_LIMITS.basic;
  return null;
};

/** Extract plain LinkedIn message text from API payloads (object, JSON string, or plain text). */
export const parseLinkedinMessageText = input => {
  if (input == null) return '';
  if (typeof input === 'object') {
    if (input.message != null) return String(input.message);
    return '';
  }

  const raw = String(input).trim();
  if (!raw) return '';

  if (raw.startsWith('{') && raw.includes('"message"')) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.message != null) return String(parsed.message);
    } catch {
      // not JSON — use raw string
    }
  }

  return raw;
};

/** Convert rich-text editor HTML for a LinkedIn message back to plain text for API payloads. */
export const linkedinMessageEditorToPlain = html => {
  const text = parseLinkedinMessageText(html);
  if (!text) return '';
  if (!/<[a-z][\s\S]*>/i.test(text)) return text;

  return text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
    .replace(/<p[^>]*>/gi, '')
    .replace(/<\/p>/gi, '\n')
    .replace(/<div[^>]*>/gi, '')
    .replace(/<\/div>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

/** LinkedIn bodies use literal <br> (or newlines), not full HTML documents. */
export const formatLinkedinMessageBody = body => {
  const text = parseLinkedinMessageText(body);
  if (!text) return '';

  if (/<div[^>]*class="linkedin-message-body"/i.test(text)) return text;

  const normalized = text
    .replace(/&lt;br\s*\/?&gt;/gi, '<br>')
    .replace(/\r\n/g, '\n')
    .replace(/\n/g, '<br>');

  return `<div class="linkedin-message-body">${normalized}</div>`;
};

/** Email bodies are already HTML (often full documents). */
export const formatEmailMessageBody = body => {
  if (body == null) return '';
  const rawBody = String(body);
  const isHtmlDocument = /<html[\s\S]*<body[\s\S]*>/i.test(rawBody);
  const htmlSource = isHtmlDocument
    ? (() => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(rawBody, 'text/html');
        return doc?.body?.innerHTML || rawBody;
      } catch (error) {
        return rawBody;
      }
    })()
    : rawBody;

  const cleanedHtmlSource = htmlSource
    .replace(/<meta[\s\S]*?>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<\/?o:[^>]*>/gi, '');

  const normalizedBody = cleanedHtmlSource
    .replace(/^\n+|\n+$/g, '')
    .replace(/^(?:<br\s*\/?>\s*)+|(?:\s*<br\s*\/?>)+$/gi, '');
  let count = 0;
  return normalizedBody.replace(/\n/g, () => {
    count++;
    return count % 2 === 0 ? '<br>' : '';
  });
};

export const getFirstNameFromEmail = email => {
  if (!email) return '';
  const first = email.split('@')[0].split('.')[0];
  return first.charAt(0).toUpperCase() + first.slice(1);
};

export const getInitials = email => {
  const namePart = email?.split('@')[0];
  return namePart
    .split(/[._\- ]/)
    .map(word => word.charAt(0).toUpperCase())
    .join('');
};

export const handleCopy = text => {
  if (!text) return;
  navigator.clipboard
    .writeText(text)
    .then(() => {
      Toast({ type: 'success', message: 'Copied to clipboard' });
    })
    .catch(err => {
      Toast({ type: 'error', message: err });
    });
};

export const senderBarOptions = [
  // { value: 'all', label: 'All' },
  // { value: 'POSITIVE_REPLY', label: 'Positive Reply' },
  // { value: 'FOLLOW_UP', label: 'Follow Up' },
  // { value: 'OPPORTUNITY', label: 'Opportunity' },
  // { value: 'NOT_INTERESTED', label: 'Not Interested' },
  // { value: 'WAITING_FOR_REPLY', label: 'Outgoing E-Mails' },
  { value: 'REPLIED', label: 'Replied' },
  { value: 'WAITING_FOR_REPLY', label: 'Outgoing' },
  // { value: 'POSITIVE_REPLY', label: 'Positive Reply' },
];


export const isImageUrlValid = (url, dummyImg) => {
  return new Promise(resolve => {
    if (!url) {
      resolve(dummyImg);
      return;
    }
    const img = new Image();

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);

    img.src = url;
  });
};

export const SEARCH_DEBOUNCE_MS = 700;

/**
 * Debounce a table/search field update into searchQuery state.
 * Keeps the input responsive via form state while delaying API-triggering updates.
 */
export const handleDebouncedSearch = (value, form, debounceRef, setSearchQuery, options = {}) => {
  const {
    delay = SEARCH_DEBOUNCE_MS,
    field = 'searchText',
    formField = 'search',
    resetPage = true,
  } = options;

  if (form?.setFieldsValue) {
    form.setFieldsValue({ [formField]: value });
  }

  if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }

  debounceRef.current = setTimeout(() => {
    setSearchQuery(prev => {
      const nextValue = value ?? '';
      if (prev[field] === nextValue) return prev;
      return {
        ...prev,
        [field]: nextValue,
        ...(resetPage ? { page: 1 } : {}),
      };
    });
  }, delay);
};

/**
 * Debounce arbitrary searchQuery field updates (e.g. sidebar filter text inputs).
 */
export const handleDebouncedQueryUpdate = (debounceRef, setSearchQuery, updates, options = {}) => {
  const { delay = SEARCH_DEBOUNCE_MS, resetPage = true } = options;

  if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }

  debounceRef.current = setTimeout(() => {
    setSearchQuery(prev => {
      const hasChange = Object.entries(updates).some(([key, val]) => prev[key] !== val);
      if (!hasChange) return prev;
      return {
        ...prev,
        ...updates,
        ...(resetPage ? { page: 1, lastSeenId: null } : {}),
      };
    });
  }, delay);
};

export const handleSearchNow = (value, setSearchQuery, options = {}) => {
  const { field = 'searchText', resetPage = true } = options;
  const nextValue = value ?? '';
  if (nextValue === undefined || nextValue === null || nextValue === '') return;

  setSearchQuery(prev => ({
    ...prev,
    [field]: nextValue,
    ...(resetPage && Object.prototype.hasOwnProperty.call(prev, 'page') ? { page: 1 } : {}),
    ...(prev.trigger != null ? { trigger: prev.trigger + 1 } : {}),
  }));
};

export const formatTime = dateString => {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, '0');
  return `${displayHours}:${displayMinutes} ${ampm}`;
};

/**
 * Recursively flattens an array of any depth to either a single value or a plain array.
 * @param {any} item - The array or item to flatten.
 * @param {boolean} getFirst - If true, returns the first non-array element found.
 * @returns {any} - The flattened array or single value.
 */
export const flattenFully = (item, getFirst = false) => {
  if (!Array.isArray(item)) return getFirst ? item : [item];
  const flat = item.flat(Infinity);
  return getFirst ? flat[0] : flat;
};
export const formatNumberToSuffix = (num, digits = 1) => {
  if (!num) return "0";

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" }
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup.slice().reverse().find(item => num >= item.value);

  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : num.toString();
};


export const getAvatarSrc = (profilePhoto, failedAvatarSources, fallbackSrc) => {
  if (!profilePhoto || failedAvatarSources?.has(profilePhoto)) {
    return fallbackSrc;
  }
  return profilePhoto;
};

export const handleAvatarError = (profilePhoto, setFailedAvatarSources) => {
  if (!profilePhoto || typeof setFailedAvatarSources !== 'function') return;
  setFailedAvatarSources(prev => {
    if (prev.has(profilePhoto)) return prev;
    const next = new Set(prev);
    next.add(profilePhoto);
    return next;
  });
};

